export const MFAStatuses = {
  PENDING: 'PENDING',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  ERROR: 'ERROR'
};
